import React from "react";
import Helmet from "react-helmet";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import config from "../../data/SiteConfig";
import "../styles/index.scss";

export default class MainLayout extends React.Component {
  render() {
    const {children, location: {pathname}} = this.props;
    return (
      <div>
        <Helmet>
          <meta name="description" content={config.siteDescription} />
        </Helmet>
        <NavBar path={pathname} />
        <div style={{minHeight: "90vh"}}>
          { children() }
        </div>
        <Footer config={config} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx